import type { ReactNode } from 'react';

import { Button } from '@revelio/ui';

import styles from './impersonationModal.module.css';

interface ImpersonationModalActionsProps {
  onResetImpersonation: () => void;
  onCancel: () => void;
  onApply: () => void;
  applyLabel?: string;
  applyDisabled?: boolean;
  summary?: ReactNode;
}

export function ImpersonationModalActions({
  onResetImpersonation,
  onCancel,
  onApply,
  applyLabel = 'Apply',
  applyDisabled = false,
  summary,
}: ImpersonationModalActionsProps) {
  return (
    <div className={styles.actionsBar}>
      <Button
        variant="outlined"
        color="destructive"
        onClick={onResetImpersonation}
        data-testid="reset-impersonation-settings-button"
      >
        Reset Impersonation
      </Button>
      {summary && (
        <span
          className={styles.summary}
          data-testid="impersonation-apply-summary"
        >
          {summary}
        </span>
      )}
      <div className={styles.actionsGroup}>
        <Button variant="ghost" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={onApply}
          disabled={applyDisabled}
          data-testid="apply-custom-overrides-button"
        >
          {applyLabel}
        </Button>
      </div>
    </div>
  );
}
